import proj1 from "../assets/proj1.jpg";
export const ProjectList = [
  {
    name: "Smart Mirror",
    image: proj1,
  },
];
